/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useRecoilValue } from "recoil";

// store
import { isMobileWidthAtom } from "store/ui/atom";

const rootCss = (props, isMobileWidth) => {
  const width = props.w
    ? `${props.w}px`
    : `${isMobileWidth ? "100%" : "198px"}`;

  return css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${props.fullWidth ? "100%" : width};
    height: ${isMobileWidth ? "48px" : "65px"};
    font-size: ${isMobileWidth ? "14px" : "18px"};
    color: ${props.colors ?? "#c09260"};
    background-color: ${props.bgColor ?? "#ffffff"};
    border: solid 1px #c09260;
    border-radius: 8px;
  `;
};

const rootDisabled = css`
  opacity: 0.5;
  cursor: default;
`;

/**
 * @file Button Components
 */
const Button = (props) => {
  const isMobileWidth = useRecoilValue(isMobileWidthAtom);

  const {
    variant, // 1차 분류
    preset, // 2차 분류
    type = "button",
    onClick,
    disabled,
    children,
    custom = [],
  } = props;

  const root = rootCss(props, isMobileWidth);

  // 버튼
  const rootPrimary = css`
    border: solid 1px #c09260;
    background-color: ${(() => {
      switch (parseInt(preset, 10)) {
        case 1:
          return "#ffffff";
        case 2:
          return "#c09260";
        default:
          return null;
      }
    })()};
  `;
  const rootSecondary = css`
    border: ${(() => {
      switch (parseInt(preset, 10)) {
        case 1:
          return "solid 1px #a89a8b";
        case 2:
          return "solid 1px #a89a8b";
        default:
          return null;
      }
    })()};
    background-color: ${(() => {
      switch (parseInt(preset, 10)) {
        case 1:
          return "#a89a8b";
        case 2:
          return "#ffffff";
        default:
          return null;
      }
    })()};
  `;
  const rootPrimaryHover = css`
    border: 1px solid #c09260;
    background-color: #ffffff;

    & span {
      color: #c09260;
    }

    &:hover {
      border: 1px solid #c09260;
      background-color: #c09260;

      & span {
        color: #ffffff;
      }
    }
  `;
  const rootSecondaryHover = css`
    border: 1px solid #a89a8b;
    background-color: #ffffff;

    & span {
      color: #a89a8b;
    }

    &:hover {
      border: 1px solid #a89a8b;
      background-color: #a89a8b;

      & span {
        color: #ffffff;
      }
    }
  `;

  // 라벨
  const labelPrimary = css`
    color: ${(() => {
      switch (parseInt(preset, 10)) {
        case 1:
          return "#c09260";
        case 2:
          return "#ffffff";
        default:
          return null;
      }
    })()};
  `;
  const labelSecondary = css`
    color: ${(() => {
      switch (parseInt(preset, 10)) {
        case 1:
          return "#ffffff";
        case 2:
          return "#a89a8b";
        default:
          return null;
      }
    })()};
  `;

  return (
    <button
      css={[
        root,
        (() => {
          switch (variant) {
            case "primary":
              return rootPrimary;
            case "secondary":
              return rootSecondary;
            case "primaryHover":
              return rootPrimaryHover;
            case "secondaryHover":
              return rootSecondaryHover;
            default:
              return null;
          }
        })(),
        disabled && rootDisabled,
        ...custom,
      ]}
      className="component-button"
      onClick={(e) => {
        e.stopPropagation(); // 이벤트 버블링 차단
        !disabled && onClick && onClick(e);
      }}
      type={type}
    >
      <span
        css={[
          (() => {
            switch (variant) {
              case "primary":
                return labelPrimary;
              case "secondary":
                return labelSecondary;
              default:
                return null;
            }
          })(),
        ]}
      >
        {children}
      </span>
    </button>
  );
};

export default Button;
